const isProduction = process.env.NODE_ENV === 'production'

export default {
  desktopThreshold: 940,
  googleApiKey: 'AIzaSyBPaP-oOOmeVMM68WGg42RDXsucpcrhjEI',
  googleImagePath: isProduction
    ? '/etc/clientlibs/frontend/sanitas-ovp-webpack/img/google/'
    : './img/google/',
  microserviceBaseUrl: process.env.VUE_APP_SANITAS_MICROSERVICE_URI,
  resourceBaseUrl: process.env.VUE_APP_SANITAS_RESOURCE_URI,
  unbluServerUrl: 'https://unblu.cloud',
  unbluApiKey: 'LLviJ-mFR0i957NPwwhB7Q',
}
